export default __webpack_public_path__ + "static/media/about-3.f1ca848d.jpg";